import { get, post } from '@/http/axios';

import { baseUrl } from '@/config/website';

export const loginByUsername = (userInfo) => post(baseUrl + '/backstage/login', userInfo);

export const sendCode = (phone) => get(baseUrl + '/backstage/smsCode/' + phone);
